import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../../services/apis";

export function* handleAllCommodities() {
  try {
    const res = yield call(API.fetchAllCommodities);
    const { data } = res;
    yield put(actions.fetchCommoditiesSuccess(data));
  } catch (err) {
    yield put(actions.fetchCommoditiesFailure(err?.response?.data));
  }
}

export function* handleCommodityWiseDetailedOrders({ payload }) {
  try {
    const res = yield call(API.fetchLabCommodityWiseDetailedOrders, payload);
    const { data } = res;
    yield put(actions.getCommodityWiseDetailedOrdersSuccess(data));
    payload.onSuccess();
  } catch (err) {
    yield put(actions.getCommodityWiseDetailedOrdersFailure(err?.response?.data));
     payload.onFailure();
  }
}


/**
 * Root saga manages watcher lifecycle
 */
export function* commodityDetailedSaga() {
  yield takeLatest(actions.fetchCommodities.type, handleAllCommodities);
  yield takeLatest(actions.getCommodityWiseDetailedOrders.type, handleCommodityWiseDetailedOrders);
 
}
